import Request from '@/core/QuRequest';

const req = new Request();

export default {
  methods: {
    // 获取统计数据
    async customerMyStatistics() {
      try {
        const res = await req.send(
          req.Apis.sales.customer.customerMyStatistics,
        );
        if (res.code === 200) {
          this.statistics = res.data;
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },

    // 我的客保接口
    async customerMyCustomerProtected(data) {
      const params = { ...data };
      params.page = this.page;
      params.page_size = this.pageSize;

      try {
        const res = await req.send(
          req.Apis.sales.customer.customerMyCustomerProtected,
          params,
        );
        if (res.code === 200) {
          const { data, total } = res.data;
          this.list = data;
          this.total = Number(total);
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },

    async exportToPublic(params) {
      try {
        const { customer_id, product_id } = params;
        const res = await req.send(
          req.Apis.sales.customerStage2.exportToPublic,
          {
            customer_id,
            product_id,
          },
        );
        if (res.code === 200) {
          this.$message.success('释放成功！');
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },

    // 获取品牌
    async getBrands() {
      try {
        const res = await req.send(req.Apis.sales.common.config, {
          type: '2',
        });
        if (res.code === 200) {
          this.brands = [...res.data] || [];
        }
      } catch (err) {
        console.error(`获取品牌失败：${err.message || '未知错误'}`);
      }
    },
  },
};
